export default __webpack_public_path__ + "static/7-04bba71cbe23eddcf8b598f2e01f28d4.jpg";